// src/pages/PainelCliente/TikpagExperienceVitrine.jsx
// Vitrine de experiências. Mudanças: não quebra quando a experiência não tem
// PIN vinculado, fecha o detalhe com Esc e segue o visual do painel.

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Medal, Sparkles, X } from "lucide-react";
import axios from "../../axiosConfig";
import "./TikpagExperienceVitrine.css";

export default function TikpagExperienceVitrine() {
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [dados, setDados] = useState(null);
  const [experiencia, setExperiencia] = useState(null);

  useEffect(() => {
    axios
      .get("/experience/vitrine")
      .then(({ data }) => setDados(data))
      .catch((err) => {
        console.error(err);
        setErro("Não foi possível carregar as experiências agora.");
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!experiencia) return;
    const esc = (e) => e.key === "Escape" && setExperiencia(null);
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", esc);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", esc);
    };
  }, [experiencia]);

  const categorias = Array.isArray(dados?.categorias) ? dados.categorias : [];

  return (
    <div className="xv">
      <Link to="/painel-cliente/tikpag-experience" className="xv-voltar">
        <ArrowLeft size={16} aria-hidden="true" />
        Voltar para minha jornada
      </Link>

      <header className="tk-cabecalho-pagina">
        <div>
          <h1 className="tk-titulo-pagina">Experiências</h1>
          <p className="tk-subtitulo-pagina">
            Algumas das experiências que você pode escolher ao conquistar um PIN no Tikpag Experience.
          </p>
        </div>
      </header>

      {loading ? (
        <div className="xv-grade">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="tk-skeleton xv-skeleton" />
          ))}
        </div>
      ) : erro ? (
        <div className="tk-vazio">
          <strong>{erro}</strong>
        </div>
      ) : categorias.length === 0 ? (
        <div className="tk-vazio">
          <strong>Nenhuma experiência disponível no momento</strong>
        </div>
      ) : (
        categorias.map((categoria) => (
          <section key={categoria.id} className="xv-categoria">
            <h2 className="tk-secao-titulo">
              {categoria.icone && <span aria-hidden="true">{categoria.icone} </span>}
              {categoria.nome}
            </h2>
            <div className="xv-grade">
              {(categoria.experiencias || []).map((item) => (
                <button key={item.id} type="button" className="xv-card" onClick={() => setExperiencia(item)}>
                  <span className="xv-card-foto">
                    {item.imagem_url ? <img src={item.imagem_url} alt="" loading="lazy" /> : <Sparkles size={32} aria-hidden="true" />}
                  </span>
                  <span className="xv-card-corpo">
                    <strong>{item.titulo}</strong>
                    {item.fornecedor && <span className="xv-fornecedor">{item.fornecedor}</span>}
                    {item.pin?.nome && (
                      <span className="xv-pin">
                        <Medal size={14} aria-hidden="true" /> PIN {item.pin.nome}
                      </span>
                    )}
                  </span>
                </button>
              ))}
            </div>
          </section>
        ))
      )}

      {experiencia && (
        <div className="xv-modal" onClick={() => setExperiencia(null)}>
          <div
            className="xv-modal-caixa"
            role="dialog"
            aria-modal="true"
            aria-labelledby="xv-modal-titulo"
            onClick={(e) => e.stopPropagation()}
          >
            <button type="button" className="xv-modal-fechar" aria-label="Fechar" onClick={() => setExperiencia(null)}>
              <X size={20} />
            </button>
            {experiencia.imagem_url && <img className="xv-modal-foto" src={experiencia.imagem_url} alt="" />}
            <div className="xv-modal-corpo">
              <h2 id="xv-modal-titulo">{experiencia.titulo}</h2>
              <dl>
                {experiencia.fornecedor && (
                  <div>
                    <dt>Fornecedor</dt>
                    <dd>{experiencia.fornecedor}</dd>
                  </div>
                )}
                {experiencia.pin?.nome && (
                  <div>
                    <dt>PIN necessário</dt>
                    <dd>{experiencia.pin.nome}</dd>
                  </div>
                )}
              </dl>
              {experiencia.descricao && <p className="xv-descricao">{experiencia.descricao}</p>}
              <p className="xv-aviso">
                Você poderá escolher esta experiência quando conquistar o PIN correspondente. A disponibilidade pode
                variar conforme a sua cidade.
              </p>
              <button type="button" className="tk-btn tk-btn--escuro" onClick={() => setExperiencia(null)}>
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
